import styled from 'styled-components';

const Svg = styled.svg`
  width: 44px;
  height: 44px;

  @media (max-width: 650px) {
    width: 32px;
    height: 32px;
  }
`;

const IconClose = () => (
  <Svg
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="44" height="44" rx="22" fill="#F1F0F0" />
    <path
      d="M27.7694 17.5254L26.4141 16.1701L22.0001 20.5841L17.586 16.1699L16.2307 17.5252L20.6448 21.9393L16.1699 26.4143L17.5252 27.7695L22.0001 23.2946L26.4749 27.7694L27.8301 26.4141L23.3554 21.9393L27.7694 17.5254Z"
      fill="#333030"
    />
  </Svg>
);

export default IconClose;
